<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px" />
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
                <tr>
                  <th>Sl</th>
                  <th>Description</th>
                  <th>Trainee Count</th>
                  <th>Trainee Percentage</th>
                </tr>
              </thead>
              <tbody v-if="flag">
                <tr>
                  <td>1</td>
                  <td>Self Employment</td>
                  <td>{{employmentSatatus.self_employment.total.toLocaleString('en-BD')}}</td>
                  <td>{{((employmentSatatus.self_employment.total/ employmentSatatus.total_trainee) * 100).toFixed(2)}}%</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Job Holder</td>
                  <td>{{employmentSatatus.job_holder.total}}</td>
                   <td>{{((employmentSatatus.job_holder.total/ employmentSatatus.total_trainee) * 100).toFixed(2)}}%</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Income From Trade</td>
                  <td>{{employmentSatatus.income_from_trade.total}}</td>
                  <td>{{((employmentSatatus.income_from_trade.total/ employmentSatatus.total_trainee) * 100).toFixed(2)}}%</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Others</td>
                  <td>{{employmentSatatus.others.total}}</td>
                  <td>{{((employmentSatatus.others.total/ employmentSatatus.total_trainee) * 100).toFixed(2)}}%</td>
                </tr>
                <tr>
                  <td colspan="2">Total</td>
                  <td>{{employmentSatatus.total_trainee.toLocaleString('en-BD')}}</td>
                  <td>100%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";
import moment from "moment";

export default {
  page: {
    title: "Income From Trade Info",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      spinner: false,
      title: "Income From Trade",
      dataCount: 0,
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Income From Trade",
          active: true
        }
      ],
      employmentSatatus: {},
      flag: false,
    };
  },

  mounted() {
    this.getEmploymentStatus();
  },
  methods: {
    getEmploymentStatus() {
      http.get("api/trainee/iga/employment/status").then(response => {
        if (!response.error) {
          this.flag = true;
          this.employmentSatatus = response.data;
        }
      });
    }
  },
};
</script>
